import React from 'react';
import {ReactComponent as WorkshopIcon} from "../../../Assets/Icons/workshop.svg";
import {ReactComponent as AssignmentIcon} from "../../../Assets/Icons/assignment.svg";
import {ReactComponent as DiscussionIcon} from "../../../Assets/Icons/discussion.svg";
import {ReactComponent as GroupAssignmentIcon} from "../../../Assets/Icons/group assignment.svg";
import styled from "styled-components";


const IconWrapper = styled.div`
  svg {
    g#Mask {
      fill: ${ props => props.color}
      
      path {
        fill: ${ props => props.color}
      }
    }
    g#Mask2 {
      fill: ${ props => props.color}
    }
    g#Group-2 {
      stroke: ${ props => props.color}
    }
  }
`;

export default  function ActivitiesIcon(props) {
  const type = props.type;
  const color = props.color;

  return (
    <IconWrapper
      color={color}
    >
      { type &&
       <>
         {
           type.toLowerCase() === 'workshop / lab' &&
           <WorkshopIcon/>
         }
         {
           type.toLowerCase() === 'individual assignment' &&
           <AssignmentIcon/>
         }
         {
           type.toLowerCase() === 'stimulus / discussion' &&
           <DiscussionIcon/>
         }
         {
           type.toLowerCase() === 'group assignment' &&
           <GroupAssignmentIcon/>
         }
       </>
      }
    </IconWrapper>
  )
};
